module.exports = __webpack_public_path__ + "static/media/deeplens.7503a718.png";